import { useState } from "react"

import { useForm } from "@tanstack/react-form"

import { Button } from "@/components/ui/Button"
import { Input } from "@/components/ui/Input"

interface CurriculumStepProps {
  value: string
  onChange: (value: string) => void
  onValidation?: (isValid: boolean) => void
}

const CURRICULUM_OPTIONS = [
  { value: "CKLA", label: "CKLA" },
  { value: "Pearson", label: "Pearson" },
  { value: "CambriLearn", label: "CambriLearn" },
  { value: "i-ready", label: "i-ready" },
  { value: "McGraw Hill", label: "McGraw Hill" },
  { value: "Great Minds", label: "Great Minds" },
  { value: "HMH", label: "HMH" },
  { value: "Discovery K12", label: "Discovery K12" },
  { value: "Other", label: "Other ✍" },
]

export function CurriculumStep({
  value,
  onChange,
  onValidation,
}: CurriculumStepProps) {
  const [showOtherInput, setShowOtherInput] = useState(false)
  const [otherValue, setOtherValue] = useState("")

  const form = useForm({
    defaultValues: {
      curriculum: value,
    },
  })

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  const handleOptionClick = (optionValue: string, field: any) => {
    if (optionValue === "Other") {
      setShowOtherInput(true)
      field.handleChange("")
      onChange("")
      onValidation?.(false)
    } else {
      setShowOtherInput(false)
      setOtherValue("")
      field.handleChange(optionValue)
      onChange(optionValue)
      onValidation?.(true)
    }
  }

  return (
    <div className="tw-text-center tw-space-y-8">
      <h2 className="tw-text-3xl tw-font-bold tw-text-gray-800">
        What curriculum is this work based on?
      </h2>

      <form.Field name="curriculum">
        {(field) => {
          return (
            <div className="tw-max-w-3xl tw-mx-auto tw-space-y-6">
              <div className="tw-grid tw-grid-cols-3 tw-gap-4">
                {CURRICULUM_OPTIONS.map((option) => (
                  <Button
                    key={option.value}
                    type="button"
                    variant="selectable"
                    size="card"
                    selected={
                      (option.value === "Other" && showOtherInput) ||
                      field.state.value === option.value
                    }
                    onClick={() => handleOptionClick(option.value, field)}
                  >
                    {option.label}
                  </Button>
                ))}
              </div>

              {showOtherInput && (
                <div className="tw-max-w-md tw-mx-auto tw-mt-6">
                  <Input
                    type="text"
                    placeholder="Enter curriculum name..."
                    value={otherValue}
                    onChange={(e) => {
                      const value = e.target.value
                      setOtherValue(value)
                      field.handleChange(value)
                      onChange(value)
                      onValidation?.(value.trim() !== "")
                    }}
                    className="tw-w-full tw-px-4 tw-py-3 tw-rounded-lg tw-border-2 tw-border-gray-300 focus:tw-border-green-500 focus:tw-outline-none tw-text-center"
                    autoFocus
                  />
                </div>
              )}
            </div>
          )
        }}
      </form.Field>
    </div>
  )
}
